<template>
  <div class="slider-container" :class="{ moving: isMoving, idle: !isMoving }">
    <div
      class="slider h-full absolute top-0 left-0 w-[80%] mx-[10%]"
      @mousemove="handleMouseMove"
      @click="handleClick"
      @wheel="handleScroll"
      @touchstart="startTouch"
      @touchmove="moveTouch"
      @keydown="handleKeydown"
      tabindex="0"
    >
      <div class="slide-indicator fixed top-2 right-2 flex items-center">
        <RandomText class="text-3xl"
          >{{ currentSlide + 1 }}/{{ slides.length }}</RandomText
        >
        <a href="https://out.nurjordan.com">
          <Icon icon="iwwa:close" width="30px" weight="regular" />
        </a>
      </div>
      <div
        class="slides h-full"
        :style="{ transform: `translateY(-${currentSlide * 100}%)` }"
      >
        <div class="slide h-full" v-for="(slide, index) in slides" :key="index">
          <RandomText
            v-if="slide.type === 'text'"
            class="text-slide text-2xl max-w-[750px]"
          >
            {{ slide.content }}
          </RandomText>
          <div v-else-if="slide.type === 'image'" class="image-slide">
            <img
              :src="slide.content"
              alt="Slide Image"
              class="w-auto max-h-[600px] rounded-lg"
              loading="lazy"
            />
          </div>
          <div v-else-if="slide.type === 'video'" class="video-slide">
            <video
              loop
              autoplay
              alt="Slide Video"
              class="w-auto max-h-[600px] rounded-lg"
            >
              <source :src="slide.content" type="video/mov" />
            </video>
          </div>
        </div>
      </div>
      <!-- <button @click="prevSlide">Prev</button>
    <button @click="nextSlide">Next</button> -->
    </div>
  </div>
</template>

<script>
import RandomText from "@/components/RandomText.vue";
export default {
  components: {
    RandomText,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSlide: 0,
      touchStartY: 0,
      touchEndY: 0,
      isScrolling: false,
      cursorX: 0,
      cursorY: 0,
      isMoving: false,
      idleTimeout: null,
    };
  },
  methods: {
    nextSlide() {
      if (!this.isScrolling) {
        if (this.currentSlide < this.slides.length - 1) {
          this.currentSlide++;
        } else {
          this.currentSlide = 0;
        }
        this.preventScrollForAWhile();
      }
    },
    prevSlide() {
      if (!this.isScrolling) {
        if (this.currentSlide > 0) {
          this.currentSlide--;
        } else {
          this.currentSlide = this.slides.length - 1; // Vuelve a la última diapositiva
        }
        this.preventScrollForAWhile();
      }
    },
    handleScroll(event) {
      if (this.isScrolling) return;

      if (event.deltaY > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    },
    startTouch(event) {
      this.touchStartY = event.touches[0].clientY;
    },
    moveTouch(event) {
      if (this.isScrolling) return;
      this.touchEndY = event.touches[0].clientY;
      if (this.touchStartY - this.touchEndY > 50) {
        this.nextSlide();
      }
      if (this.touchStartY - this.touchEndY < -50) {
        this.prevSlide();
      }
    },
    handleMouseMove(event) {
      this.cursorX = event.clientX;
      this.cursorY = event.clientY;

      this.isMoving = true;

      clearTimeout(this.idleTimeout);
      this.idleTimeout = setTimeout(() => {
        this.isMoving = false;
      }, 1000);
    },
    handleClick(event) {
      const halfHeight = window.innerHeight / 2;
      if (event.clientY < halfHeight) {
        this.prevSlide();
      } else {
        this.nextSlide();
      }
    },
    preventScrollForAWhile() {
      this.isScrolling = true;
      setTimeout(() => {
        this.isScrolling = false;
      }, 1300); // 1 segundo de pausa entre cambios
    },
    closeClock() {},
    handleKeydown(event) {
      if (event.key === "ArrowUp") {
        this.prevSlide();
      } else if (event.key === "ArrowDown") {
        this.nextSlide();
      }
    },
    handleVideoPlayback() {
      const videos = this.$refs.videos; // Refs de los videos
      if (!videos) return;

      // Verificar si hay varios videos o solo uno
      const videoArray = Array.isArray(videos) ? videos : [videos];

      videoArray.forEach((video, index) => {
        if (index === this.currentSlide) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0; // Reiniciar los videos no visibles
        }
      });
    },
  },
};
</script>

<style>
.slider-container {
  width: calc(100% - 100px); /* Ancho total menos 100px */
  margin: 0 auto; /* Centrar horizontalmente */
}
.slider {
  position: relative;
  overflow: hidden;
  cursor: none;
}

.cursor-text {
  content: attr(data-cursor-text);
  top: 50%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: black;
  pointer-events: none;
  z-index: 1000;
}

.slides {
  display: flex;
  flex-direction: column;
  transition: transform 0.5s ease-in-out;
}

.slide {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.text-slide {
  text-align: center;
}

button {
  position: absolute;
  bottom: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:nth-of-type(1) {
  left: 10px;
}

button:nth-of-type(2) {
  right: 10px;
}

.slide-indicator {
  position: fixed;
  top: 16px; /* Ajusta según sea necesario */
  right: 16px; /* Ajusta según sea necesario */
  padding: 5px 10px;
  border-radius: 5px;
}

.moving {
  display: none;
}

.idle {
  display: block;
}
</style>